export default class ProjectsConnect {

    constructor(projectsData) {

        // Projects with "disabled": true are left out completely
        this._projectsData = Object.fromEntries(
            Object.entries(projectsData).filter(([, project]) => project.disabled !== true)
        );
        this._allTags = this.getAllTags();
    }

    getAllTags() {

        const tags = new Set();

        for (const project of Object.values(this._projectsData)) {

            if (project.tags) {

                for (const tag of project.tags) {
                    tags.add(tag);
                }
            }
            else
                console.log(project.name, "has no tags");

        }

        return tags;
    }

    displayProjects(container) {

        for (const project of Object.values(this._projectsData)) {

            const projectHtml = this.getProjectHtml(project);
            container.appendChild(projectHtml);
        }
    }

    getProjectHtml(projectData) {

        const card = this.createHtmlElement("div", "", null, "", ["project-card"]);

        if (projectData.cover) {

            const img = this.createHtmlElement("img", "", card, "", ["project-img"]);
            img.src = projectData.cover;
            img.alt = projectData.name;
        }

        const content = this.createHtmlElement("div", "", card, "", ["project-content"]);

        const textArea = this.createHtmlElement("div", "", content, "", ["project-text-area"]);
        const title = this.createHtmlElement("h3", projectData.name, textArea, "", []);
        const tags = this.createHtmlElement("p", projectData.tags.join(", "), textArea, "", []);
        const button = this.createHtmlElement("button", "View Project", content, "", []);

        button.addEventListener("click", () => {
            window.location.href = projectData.page;
        });

        return card;
    }

    createHtmlElement(type, text, parent, id, classes) {

        const element = document.createElement(type);

        if (text != "")
            element.textContent = text;

        if (parent != null && parent != undefined)
            parent.appendChild(element);

        if (id != "")
            element.id = id;

        if (classes && classes.length > 0)
            element.classList.add(classes);

        return element;
    }
}